import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

export const useDownloadPortabilityFile = ({
  downloadPortabilityFileStorageAction,
  downloadPortabilityFileSFTPAction,
  downloadPortabilityFile,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [titleDialog, setTitleDialog] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [processCompleted, setProcessCompleted] = useState(false);

  useEffect(() => {
    if (downloadPortabilityFile?.status === 200) {
      setLoading(false);
    } else if (downloadPortabilityFile?.payload?.response?.status > 200) {
      setDialogMessage(downloadPortabilityFile?.payload?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [downloadPortabilityFile]);

  const onSubmit = async (date, downloadType, downloadSource) => {
    if (!date || !downloadType) {
      setErrorMessage('Ingresa tipo de descarga y fecha para continuar');
      return;
    }
    setLoading(true);
    try {
      if (downloadType === 'SFTP') {
        await downloadPortabilityFileSFTPAction(date, downloadSource);
      } else {
        await downloadPortabilityFileStorageAction(date);
      }

      const message =
        downloadType === 'SFTP'
          ? 'Descarga exitosa! Se ha reemplazado el archivo de portabilidades en el Storage'
          : 'Descarga exitosa!';

      setDialogMessage(message);
      setIsDialogOpen(true);
      setErrorMessage('');
      setProcessCompleted(true);
    } catch (e) {
      let match;
      if (!e.code) {
        match = e.match(/'message':\s*'([^']+)'/);
      }
      let errorObj;
      try {
        errorObj = typeof e === 'string' ? JSON.parse(e) : e;
      } catch {
        errorObj = {};
      }
      const errorMessage = match ? match[1] : 'Contacta a soporte.';
      setErrorMessage('Ocurrió un error al descargar el archivo.');
      setTitleDialog(errorObj.title || 'Error');
      setDialogMessage(errorObj.detail || `Error al descargar el archivo: ${errorMessage}`);
      setIsDialogOpen(true);
    }
    setLoading(false);
  };

  const handleClose = () => {
    if (isDialogOpen) {
      setIsDialogOpen(false);
    } else {
      setIsDialogOpen(false);
    }
  };

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
    loading,
    isDialogOpen,
    setIsDialogOpen,
    dialogMessage,
    handleClose,
    errorMessage,
    setErrorMessage,
    processCompleted,
    setProcessCompleted,
    titleDialog,
  };
};
